import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import {plugin, defaultConfig } from '@formkit/vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
require('./assets/main.scss');
import api from "@/services/api";
import formkitConfig from './formkit.config.js';
import * as ConfirmDialog from 'vuejs-confirm-dialog';
import vue3GoogleLogin from 'vue3-google-login';
import i18n from './i18n.js'
import helpers from '@/services/helpers'
// import VueAppleLogin from "vue-apple-login/index";

// import en from './locales/en.json';
// import de from './locales/de.json';
// import fr from './locales/fr.json';
// import lb from './locales/lb.json';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faTrash, faGlobe, faDiagramProject, faUsersGear,
faUserGroup, faTruckField, faBuilding, faEye, faStar, faMoneyBillTrendUp,
faPenToSquare, faTableColumns, faClockRotateLeft, faPersonChalkboard, faAngleDown,
faEllipsisVertical, faArrowLeft, faArrowRight, faPaperclip, faLink,
faUserGraduate, faFilter, faMagnifyingGlass, faRightLeft, faCheck,
faEnvelope, faBan, faXmark, faLock, faFloppyDisk, faArrowUpRightFromSquare,
faDownload, faSquareRootVariable, faMagnifyingGlassChart} from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faTrash)
library.add(faGlobe)
library.add(faDiagramProject)
library.add(faUsersGear)
library.add(faUserGroup)
library.add(faTruckField)
library.add(faBuilding)
library.add(faEye)
library.add(faStar)
library.add(faMoneyBillTrendUp)
library.add(faPenToSquare)
library.add(faTableColumns)
library.add(faClockRotateLeft)
library.add(faPersonChalkboard)
library.add(faAngleDown)
library.add(faEllipsisVertical)
library.add(faArrowLeft)
library.add(faArrowRight)
library.add(faPaperclip)
library.add(faLink)
library.add(faUserGraduate)
library.add(faFilter)
library.add(faMagnifyingGlass)
library.add(faRightLeft)
library.add(faCheck)
library.add(faEnvelope)
library.add(faBan)
library.add(faXmark)
library.add(faLock)
library.add(faFloppyDisk)
library.add(faArrowUpRightFromSquare)
library.add(faDownload)
library.add(faSquareRootVariable)
library.add(faMagnifyingGlassChart)

// Create my internationalization feature
// const i18n = createI18n({
//     locale: "en",
//     fallbackLocale: "en",
//     messages: {de, en, fr, lb},
//   something vue-i18n options here ...
// })

const app = createApp({
    extends: App,
});
app.config.globalProperties.$i18n = i18n;
app.use(router).use(api).use(store).use(i18n).use(plugin, defaultConfig(formkitConfig)).use(ConfirmDialog);
app.use(vue3GoogleLogin, {
    clientId: '141631509488-s4h54b1f1ec1a0vfopj92cto7mnfeg6q.apps.googleusercontent.com'
});
app.use(helpers, {})
app.config.globalProperties.$store = store
// app.use(VueAppleLogin, {
//     clientId: 'portal.evity.earth',
//     scope: 'name email',
//     redirectURI: 'https://www.example.com',
//     state: '123456789',
//     usePopup: true,
// });
app.component('font-awesome-icon', FontAwesomeIcon);
app.mount('#app')
